import { PrimeNGConfigType } from "primeng/config";
import { definePreset } from "@primeng/themes";
import Material from "@primeng/themes/material";

export const appDarkModeClass = "vig-theme--dark";

export const appPrimeNGTheme = definePreset(Material, {
  semantic: {
    primary: {
      50: "#f2fbf8",
      100: "#d2f5e9",
      200: "#a5ead3",
      300: "#70d8b9",
      400: "#42bf9d",
      500: "#29a385",
      600: "#218e75",
      700: "#1c6958",
      800: "#1b5448",
      900: "#1b463d",
      950: "#0a2925",
    },
  },
});

export const appPrimeNGConfig: PrimeNGConfigType = {
  ripple: true,
  theme: {
    preset: appPrimeNGTheme,
    options: {
      darkModeSelector: `.${appDarkModeClass}`,
    },
  },
};
